import React, { useState, useEffect, useContext } from "react";
import { Page } from "@shopify/polaris";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../../../components/global/appContext";
import {
  useGetThemeSettings,
  useUpdateThemeSettings,
} from "../../../../../hooks/queries/themes";
import ThemeSettingsEmptyState from "./EmptyState";
import ThemeSettingsGUI from "./SettingsGUI";
import useCompare from "../../../../../hooks/useCompare";
import ThemeLanguageSkeleton from "../language/Skeleton";
// import NewSchemaTest from "./NewSchemaTest";

export default function ThemeSettingsEdit(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  let { id } = useParams();

  const { data, isError } = useGetThemeSettings(id);
  useEffect(() => setThemeSettings(data), [data]);
  const [themeSettings, setThemeSettings] = useState(data);

  const updateThemeSettingsMutation = useUpdateThemeSettings(id, {
    onSuccess: () => {
      appContext.setMessage(t("themes.settings.messages.saveSuccess"));
    },
    onError: (e) => {
      appContext.setMessage(
        `${t("themes.settings.messages.saveError")}: ${e.response.data.join(", ")}`,
        true
      );
    },
  });

  function updateSettingsSchemaField(value, categoryKey, fieldKey) {
    let newThemeSettings = {
      ...themeSettings,
      [categoryKey]: { ...themeSettings[categoryKey], [fieldKey]: value },
    };
    setThemeSettings(newThemeSettings);
  }

  const settingsHaveChanged = !useCompare(themeSettings, data);

  // Handle form submission (triggered by Save Bar)
  const handleSubmit = (e) => {
    e.preventDefault();
    updateThemeSettingsMutation.mutate(themeSettings);
  };

  // Handle form reset (triggered by Discard button in Save Bar)
  const handleReset = (e) => {
    e.preventDefault();
    setThemeSettings(data);
  };

  if (isError) return <p>{t("common.error")}</p>;
  if (!themeSettings) return <ThemeLanguageSkeleton />;
  if (!Object.keys(themeSettings).length) return <ThemeSettingsEmptyState />;

  return (
    <form 
      data-save-bar 
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
    <Page>
      <ThemeSettingsGUI
        settingsSchema={themeSettings}
        updateSettingsSchemaField={updateSettingsSchemaField}
      />
    </Page>
    </form>
  );
}
